// extracted by mini-css-extract-plugin
export default {"container":"configuration_container__MklpP","border":"configuration_border__Ohslt"};